define('vspot-angular/services/org-teachers-service',[], function () {
    'use strict';

    return ['resources.OrgTeachers', function (OrgTeachers) {

        return {
            query: function (activityId) {
                return OrgTeachers.query({ selected_activity: activityId });
            },

            save: function (postData) {
                return OrgTeachers.save(postData);
            },

            update: function (postData) {
                return OrgTeachers.update(postData);
            },

            delete: function (activityId, teacherId) {
                return OrgTeachers.delete({ selected_activity: activityId, id: teacherId });
            },

            getUserTeachers: function () {
                return OrgTeachers.getUserTeachers();
            }
        };
    }];
});

